module.exports = __webpack_public_path__ + "static/media/castledown-heavy.b7710710.eot";